"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminProvider = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_intl_1 = require("react-intl");
const menubar_context_1 = require("../../composite/menubar/menubar-context");
const navigation_context_1 = require("../../composite/navigation/navigation-context");
const admin_reindex_1 = require("./reindex/admin-reindex");
const user_context_1 = require("../user/user-context");
const admin_context_1 = require("./admin-context");
const admin_console_1 = require("./console/admin-console");
const messages_1 = require("./soap/logger/message/messages");
const lodash_1 = require("lodash");
const web_socket_context_1 = require("../web-socket/web-socket-context");
function AdminProvider({ permission, prefix, reindexUrl, soapMessagesUrl, }) {
    const { modifyItems } = React.useContext(menubar_context_1.MenubarContext);
    const { navigate } = React.useContext(navigation_context_1.NavigationContext);
    const { hasPermission } = React.useContext(user_context_1.UserContext);
    const { isWsActive } = React.useContext(web_socket_context_1.WebsocketContext);
    const menuItems = React.useMemo(() => [
        {
            label: (React.createElement(react_intl_1.FormattedMessage, { id: "EAS_MENU_ITEM_DEVTOOLS", defaultMessage: "V\u00FDvojov\u00E9 n\u00E1stroje" })),
            isActive: (pathname) => {
                return [
                    `${prefix}/admin/reindex`,
                    `${prefix}/admin/console`,
                    `${prefix}/admin/soap/logger/messages`,
                ].includes(pathname);
            },
            items: lodash_1.compact([
                {
                    label: (React.createElement(react_intl_1.FormattedMessage, { id: "EAS_MENU_ITEM_REINDEX", defaultMessage: "Reindex" })),
                    onClick: () => {
                        navigate(`${prefix}/admin/reindex`);
                    },
                },
                isWsActive
                    ? {
                        label: (React.createElement(react_intl_1.FormattedMessage, { id: "EAS_MENU_ITEM_CONSOLE", defaultMessage: "Konzole" })),
                        onClick: () => {
                            navigate(`${prefix}/admin/console`);
                        },
                    }
                    : undefined,
                soapMessagesUrl !== undefined
                    ? {
                        label: (React.createElement(react_intl_1.FormattedMessage, { id: "EAS_MENU_ITEM_SOAP_MESSAGES", defaultMessage: "SOAP komunikace" })),
                        onClick: () => {
                            navigate(`${prefix}/admin/soap/logger/messages`);
                        },
                    }
                    : undefined,
            ]),
        },
    ], [isWsActive, navigate, prefix, soapMessagesUrl]);
    const show = hasPermission(permission);
    // adds items to menu
    React.useEffect(() => {
        if (show) {
            modifyItems((items) => [...items, ...menuItems]);
        }
        return () => {
            if (show) {
                modifyItems((items) => items.filter((item) => !menuItems.includes(item)));
            }
        };
    }, [menuItems, modifyItems, show]);
    return (React.createElement(admin_context_1.AdminContext.Provider, { value: {
            reindexUrl: reindexUrl,
            soapMessagesUrl: soapMessagesUrl,
        } },
        React.createElement(react_router_dom_1.Switch, null,
            show && reindexUrl !== undefined && (React.createElement(react_router_dom_1.Route, { path: `${prefix}/admin/reindex`, component: admin_reindex_1.AdminReindex })),
            show && isWsActive && (React.createElement(react_router_dom_1.Route, { path: `${prefix}/admin/console`, component: admin_console_1.AdminConsole })),
            show && soapMessagesUrl !== undefined && (React.createElement(react_router_dom_1.Route, { path: `${prefix}/admin/soap/logger/messages/:id?`, component: messages_1.SoapMessages })))));
}
exports.AdminProvider = AdminProvider;
//# sourceMappingURL=admin-provider.js.map